import { useEffect } from "react";
import { MainLayout } from "@/components/MainLayout";
import { BudgetVsActualReport } from "@/components/construction/BudgetVsActualReport";

/**
 * Budget vs Actual Page for Construction
 *
 * NEW REPORT: Budget variance tracking and analysis
 *
 * This page provides a comprehensive comparison of budgeted vs actual costs
 * for construction works. It enables construction companies to:
 * - Monitor budget adherence across all works
 * - Identify works that are over/under budget
 * - Track overall financial performance
 * - Export data for external analysis
 *
 * Key Features:
 * - Real-time calculation of actual costs (paid expenses only)
 * - Visual indicators for budget status (red/yellow/green)
 * - Filtering and search capabilities
 * - CSV export for further analysis
 * - Summary statistics and KPIs
 *
 * The report uses the budgeted_cost field added to cost_centers table
 * and compares it against the sum of paid expenses for each work.
 */
export default function BudgetVsActualPage() {
  useEffect(() => {
    document.title = "Orçado vs. Realizado | Controle Financeiro";
  }, []);

  return (
    <MainLayout>
      <div className="container mx-auto py-6">
        <BudgetVsActualReport />
      </div>
    </MainLayout>
  );
}
